module.exports = __webpack_public_path__ + "img/contact.082c7f62.png";